import { INITIAL_LOAD_ROW_COUNT } from './TableLoadingConstants';
import getConversationSortByProperty from '../../utils/tables/getConversationSortByProperty';
import getMailItemSortByProperty from '../../utils/tables/getMailItemSortByProperty';
import datapoints from '../datapoints';
import { onReloadTableFailed, onReloadTableSucceeded } from '../table/onReloadTableCompleted';
import { logUsage } from 'owa-analytics';
import getFolderData from 'owa-mail-actions/lib/getFolderData';
import { findItemWithStartIndex } from 'owa-mail-store';
import { actionNames } from 'owa-mail-store-actions';
import findConversationWithStartIndex from 'owa-mail-store/lib/services/findConversationWithStartIndex';
import { action } from 'satcheljs/lib/legacy';
import { getBaseFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
/**
 * Reload the given table view
 * @param tableView to be reloaded
 */
export default action(actionNames.ReloadMailListTableAction)(function reloadTable(tableView) {
    // let CI be currentLoadedIndex
    // Case 1: if CI < INITIAL_LOAD_ROW_COUNT, request INITIAL_LOAD_ROW_COUNT rows, the reason is server may have more rows
    // and we would like to fill our viewport with more rows
    // Case 2: if CI >= INITIAL_LOAD_ROW_COUNT, request CI rows
    // In case 2 we would want to optimize reload performance,
    // since we currently will load all items that are in currentLoadedIndex - VSO: 11814
    var rowsToReload = Math.max(tableView.currentLoadedIndex, INITIAL_LOAD_ROW_COUNT);
    // Reload all items that we have, otherwise rows may be in an inconsistent state
    // We need to pass in the reload datapoint, because it is used in the async callback to log the service error
    // TODO: 11814: Optimize reload performance since we currently reload all items that we have
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            reloadConversationTable(tableView, rowsToReload);
            break;
        case 1 /* Message */:
            reloadItemTable(tableView, rowsToReload);
            break;
    }
    // Also refresh counts for folder
    if (tableView.tableQuery.type == 0 /* Folder */) {
        getFolderData(tableView.tableQuery.folderId);
    }
    // log number of rows reloaded
    logUsage(datapoints.reloadTable.datapoint.name, datapoints.reloadTable.datapoint.customData(rowsToReload));
});
/**
 * Reload the conversation table
 * @param tableView the conversation table view to be reloaded
 * @param rowsToReload the number of rows to reload
 */
function reloadConversationTable(tableView, rowsToReload) {
    var mailTableQuery = tableView.tableQuery;
    findConversationWithStartIndex(getBaseFolderId(mailTableQuery), 0 /* startIndex */, rowsToReload, mailTableQuery.viewFilter, getConversationSortByProperty(mailTableQuery), mailTableQuery.focusedViewFilter, mailTableQuery.requestShapeName, mailTableQuery.shouldTryToUseSessionDataResponse, getMailboxInfoFromTableQuery(mailTableQuery).requestOptions, mailTableQuery.categoryName)
        .then(function (response) {
        var responseMessage = response.findConversationResponseMessage;
        if (responseMessage.ResponseClass == 'Success') {
            onReloadTableSucceeded(tableView, responseMessage.Conversations, responseMessage.TotalConversationsInView);
        }
        else {
            onReloadTableFailed(responseMessage.ResponseCode);
        }
    })
        .catch(function (error) {
        onReloadTableFailed();
    });
}
/**
 * Reload the item table
 * @param tableView the item table view to be reloaded
 * @param number of rows to reload
 */
function reloadItemTable(tableView, rowsToReload) {
    var mailTableQuery = tableView.tableQuery;
    findItemWithStartIndex(getBaseFolderId(mailTableQuery), 0 /* startIndex */, rowsToReload, mailTableQuery.viewFilter, getMailItemSortByProperty(mailTableQuery), mailTableQuery.focusedViewFilter, mailTableQuery.requestShapeName, mailTableQuery.shouldTryToUseSessionDataResponse, getMailboxInfoFromTableQuery(mailTableQuery).requestOptions, mailTableQuery.categoryName)
        .then(function (responseMessage) {
        if (responseMessage.ResponseClass == 'Success') {
            onReloadTableSucceeded(tableView, responseMessage.RootFolder.Items, responseMessage.RootFolder.TotalItemsInView);
        }
        else {
            onReloadTableFailed(responseMessage.ResponseCode);
        }
    })
        .catch(function (error) {
        onReloadTableFailed();
    });
}
//# sourceMappingURL=reloadTable.js.map